import { inject, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Permission } from '../models/permission.model';

@Pipe({
  name: 'hasPermission',
  pure: false,
})
export class HasPermissionPipe implements PipeTransform {
  private authService = inject(AuthService);

  transform(requiredPermissions: Permission[]): boolean {
    return this.authService.hasPermission(requiredPermissions);
  }
}
